import SelectInput from "../../../Inputs/CustomInputs/SelectInput";
import EllipseButton from "../../../Buttons/EllipseButton/EllipseButton";
import { ListItem } from "../../../../../entities/UIEntities/ListItem";
import Strings from "../../../../../resources/Strings";
import classes from "../WizardForm.module.css";
import { Grid } from "@mui/material";
import { INPUTS_PROPS, VALIDATION_TYPE } from "../../../../../enums/Enums";

const TicketStep = (props) => {
  let validationsList = props?.validationsList?.map((validation, index) => new ListItem(index, validation.isFullDiscount ? VALIDATION_TYPE.FULL : VALIDATION_TYPE.PARTIAL, validation?.id));

  return (
    <>
      <div className={classes.validationContainer}>
        <div className={classes.validationTitle}>{Strings.TICKET_FOUND} </div>
        <div className={classes.grayed}>
          <div className={classes.validationLeftMargin}>
            assigned to: {props?.foundedTicketData?.contactInfo}
          </div>
        </div>
      </div>
      <div className={classes.validationMargin}>
        <Grid container spacing={1}>
          <Grid item xs={3}>
            <p className={classes.validationSubTitle}>Details</p>
            <p>Entrance Time: <span className={classes.grayed}>{props?.foundedTicketData?.entranceTime}</span></p>
            {/* <p>Parking Durtaion:</p>
                <p>Current Parking Cost:</p> */}
          </Grid>
          <Grid item xs={2} sx={{ marginTop: "13px" }}>
            <div></div>
            <div className={classes.validationSubTitle}>
              {Strings.VALIDATION_OPTION}
            </div>
            <SelectInput
              label={Strings.INPUT_LABELS.VALIDATION_TYPE}
              id={INPUTS_PROPS.VALIDATION_TYPE}
              onChange={props?.handleChange}
              list={validationsList}
              value={props?.validationType ? props?.validationType : ''}
              defaultValue={''}
            //   isStepSubmitted={props.isStepSubmitted}
            //   handleError={handleError}
            //   hasError={!isRequired(props.validationType).isValid}
            //   errorMessage={getErrorMessage(isRequired(props.validationType))}
            />
            <div className={classes.buttonContainer}>
              <div>
                <EllipseButton type="button" onClick={props?.validate} minWidth={"100px"}>
                  {Strings.VALIDATE}
                </EllipseButton>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default TicketStep;